import { Injectable, NgModule, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerGestureConfig } from '@angular/platform-browser';
import { Router, RouteReuseStrategy } from '@angular/router';
import { IonicRouteStrategy } from '@ionic/angular/standalone';
import { ImageCropperModule } from 'ngx-image-cropper';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CategoryEditComponent } from './components/category-edit/category-edit.component';
import { ServiceWorkerModule } from '@angular/service-worker'; //TODO: remove from mobile
import { environment } from '../environments/environment';
import { FirebaseModule } from 'src/app/services/firebase/firebase.module';
import {
  IonApp,
  IonButton,
  IonCheckbox,
  IonCol,
  IonGrid,
  IonIcon, IonInput,
  IonItem, IonLabel,
  IonList,
  IonRouterOutlet,
  IonRow, provideIonicAngular
} from '@ionic/angular/standalone';

import * as Sentry from "@sentry/angular";


@Injectable()
export class IonicGestureConfig extends HammerGestureConfig {
  buildHammer(element: HTMLElement) {
    return new (<any>window).Hammer(
      element,
      {
        recognizers: [
          ['press', {time: 500}],
        ]
      }
    );
  }
}

@NgModule({
  declarations: [AppComponent, CategoryEditComponent],
  imports: [
    BrowserModule,
    ImageCropperModule,
    FirebaseModule,
    AppRoutingModule,
    ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production,registrationStrategy:'registerWhenStable:5000'}),
    IonApp,
    IonRouterOutlet,
    IonRow,
    IonGrid,
    IonCheckbox,
    IonCol,
    IonList,
    IonButton,
    IonIcon,
    IonItem,
    IonLabel,
    IonInput,
  ],
  providers: [
    {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
    {provide: HAMMER_GESTURE_CONFIG, useClass: IonicGestureConfig},
    provideIonicAngular({mode: 'ios'}),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    }, {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
